import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";
import Breakpoints from "common/breakpoints";

export default makeStyles((theme: MuiTheme) => {
  const {
    palette: { primary, secondary }
  } = theme;

  return {
    managementContentHeader: {
      minHeight: theme.heightDesktopPageHeader,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      borderBottom: "1px solid #e2e2e2"
    },
    managementHeader: {
      width: "100%",
      padding: "0 20px",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      fontSize: 16
    },
    managementHeaderPart: {
      display: "flex",
      alignItems: "center"
    },
    selectTrackButton: {
      color: primary.dark,
      fontSize: 14,
      cursor: "pointer",
      [theme.breakpoints.down(Breakpoints.SM_600)]: {
        lineHeight: 1
      }
    },
    selectedBlack: {
      color: primary.main,
      fontWeight: 600
    },
    rightArrow: {
      fontSize: 14,
      margin: "0 6px",
      color: primary.dark
    },
    selectedFacilityName: {
      color: primary.dark,
      fontSize: 14,
      cursor: "pointer",
      [theme.breakpoints.down(Breakpoints.SM_600)]: {
        lineHeight: 1
      }
    },
    selectedAppName: {
      color: primary.dark,
      fontSize: 14,
      [theme.breakpoints.down(Breakpoints.SM_600)]: {
        lineHeight: 1
      }
    },
    selectedGreen: {
      color: secondary.dark,
      fontWeight: 600
    },
    closeIcon: {
      fontSize: 28,
      "&:hover": {
        cursor: "pointer"
      }
    },
    dividerLight: {
      backgroundColor: "#eee"
    },
    headerDisabled: {
      opacity: 0.5
    },
    capitalize: {
      textTransform: "capitalize"
    }
  };
});
